import { callWithNuxt } from '#app'
import { useDashboardStore } from "~/store/useDashboardStore";

export default defineNuxtRouteMiddleware( async (to) => {
  const nuxtApp = useNuxtApp()
  const dash = useDashboardStore()
  const cookie = useCookie("userToken");

  
  const path = to.path.toLocaleLowerCase();
  const requiresAuth =
    path.startsWith('/marketplace/preview') ||
    path.startsWith('/marketplace/builder') ||
    path.startsWith('/marketplace/creation') ||
    path.startsWith('/dashboard') ||
    path.startsWith('/listing-form');

  if (!requiresAuth) {
    return;
  }

  if (!cookie.value) {
    return callWithNuxt(nuxtApp, navigateTo, ['/authentication/login']);
  }

  if (!dash.getIsUserConnected) {
    try {
      await dash.fetchUserByToken();
    } catch (error) {
      console.error('Failed to hydrate user for auth guard', error);
      return callWithNuxt(nuxtApp, navigateTo, ['/authentication/login']);
    }
  }

  if (!dash.getIsUserConnected) {
    return callWithNuxt(nuxtApp, navigateTo, ['/authentication/login']);
  }

  if (!dash.getIsUserActive) {
    return callWithNuxt(nuxtApp, navigateTo, ['/authentication/verification']);
  }


})
